(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

// window.testEnv=true;

require('../../../../../BIS_KYOTO/BIS_KYOTO/common/js/form/_form_controller.js');

window.timeList = ['10:00', '13:00', '16:00'];

},{"../../../../../BIS_KYOTO/BIS_KYOTO/common/js/form/_form_controller.js":2}],2:[function(require,module,exports){
/**
 *
 * @file      form_controller.js
 *
 * @abstract  来館予約・資料請求／お問い合わせページでのform controller for AngularJS
 *
 * @updated   02/12/2015
 *
 */
'use strict';

/**
 *
 * 「送信中」のウィンドウのFOUC対策
 *
 */

document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('loader').setAttribute('style', 'opacity: 0; display: none;');
    document.getElementById('form').setAttribute('style', 'opacity: 1');
    document.getElementById('progress_window').classList.remove('initial');
});

window.addEventListener('load', function () {});

/**
 *
 * form controller for AngularJS
 *
 */
var appName = 'app';
angular.module(appName, ['ngMaterial', 'ngMessages'])
//
// @see https://material.angularjs.org/latest/#/Theming/03_configuring_a_theme
//
.config(['$mdThemingProvider', function ($mdThemingProvider) {
    $mdThemingProvider.definePalette('niho', {
        '50': '#333333',
        '100': '#333333',
        '200': '#09233d',
        '300': '#dfddd8',
        '400': '#fdfaf5',
        '500': '#333333',
        '600': '#333333',
        '700': '#fdfaf5',
        '800': '#fdfaf5',
        '900': '#fdfaf5',
        'A100': '#fdfaf5',
        'A200': '#fdfaf5',
        'A400': '#fdfaf5',
        'A700': '#fdfaf5'
    }).theme('default').primaryPalette('indigo').warnPalette('pink').backgroundPalette('niho');
}]).controller('FormController', ['$scope', '$http', '$location', '$window', function ($scope, $http, $location, $window) {
    var _this = this;

    /**
     *
     * 日付初期化
     *
     */
    this.date = new Date();
    this.date.setDate(this.date.getDate() + 1); //初期値を翌日に設定
    this.minDate = new Date();
    /**
     *
     * 来館時間リスト
     *
     */
    this.timeList = window.timeList || [];
    /**
     *
     * 住所自動入力
     *
     */
    this.fillAddress = function () {
        _this.address = document.form.address.value;
    };
    /**
     *
     * POST
     * $httpでエラーが返ってきたときは/error/を表示させる
     *
     */
    this.submit = function () {
        _this.showProgress = true;
        _this.reserveDate = _this.date.getFullYear() + '年' + (_this.date.getMonth() + 1) + '月' + _this.date.getDate() + '日';
        var postURL = '../mail/send.php';
        //
        // @see http://wordpress.honobono-life.info/code/angularjs%E3%81%AEhttp%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E3%81%AEpost%E3%81%A7%E3%83%87%E3%83%BC%E3%82%BF%E9%80%81%E4%BF%A1/
        //
        var config = {};
        $http.post(postURL, _this, config).then(function (response) {
            if (window.testEnv) {
                _this.showProgress = false;
                return;
            };
            window.location.href = 'thanks/';
        }, function (response) {
            if (window.testEnv) {
                _this.showProgress = false;
                return;
            };
            window.location.href = '../error/';
        });
    };
}]);

},{}]},{},[1]);
